import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../shared/services';
import { InspectionPlugin } from '../../shared/models/index';

@Injectable()
export class InherentRiskPluginService extends InspectionPluginService {
  public probabilityKeys = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];

  private impactKeys = [
    { value: 1, label: 'plugins.inherentrisk.impacts.notaffected' },
    { value: 2, label: 'plugins.inherentrisk.impacts.risky' },
    { value: 3, label: 'plugins.inherentrisk.impacts.risky' },
    { value: 4, label: 'plugins.inherentrisk.impacts.risky' },
    { value: 5, label: 'plugins.inherentrisk.impacts.medium' },
    { value: 6, label: 'plugins.inherentrisk.impacts.medium' },
    { value: 7, label: 'plugins.inherentrisk.impacts.high' },
    { value: 8, label: 'plugins.inherentrisk.impacts.high' },
    { value: 9, label: 'plugins.inherentrisk.impacts.high' },
    { value: 10, label: 'plugins.inherentrisk.impacts.down' }
  ];
  private impactOptions = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getImpactOptions() {
    return this.impactOptions;
  }

  public updateInherentRisk(inspectionId: string, pointId: string, pluginId: string, inherentRisk: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, inherentRisk).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.impactOptions = [];
    this.copyTranslationValues(this.impactKeys, this.impactOptions, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, inherentRisk: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, inherentRisk, 'InherentRisk').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
